<template>
  <div class="homePage-page">
    <div class="today-details-container">
      <div class="addCrops-container" @click="goback" style="width: 10%">
        <span> <i class="el-icon-arrow-left"></i>返回 </span>
      </div>
      <div class="grow-select-container" style="width: 20%">
        <div class="select-container">
          <el-cascader v-model="dialogform.dialogformModelStageId" :options="options" :props="{ expandTrigger: 'hover' }" @change="changeOne_Time" placeholder="选择大棚" collapse-tags></el-cascader>
        </div>
        <span style="color: #236cff; cursor: pointer; margin-right: 10px; font-size: 12px" @click="hanldeHomeParam()"> 参数配置 </span>
      </div>
      <div class="early-warning-container" @click="gjtzShow">
        <span class="waring_lable">预警：</span>
        <marqueeLeft v-if="alermlist.length > 0" :sendVal="alermlist"></marqueeLeft>
      </div>
      <div class="today-weather-container" style="width: 28%">
        <div class="container_1" v-if="weatherList.length > 0">
          <div class="todayW content_1">今天：天气{{ weatherList[0].textDay }} {{ weatherList[0].tempMin }}℃~{{ weatherList[0].tempMax }}℃</div>
          <div class="todayW content_1">明天：天气{{ weatherList[1].textDay }} {{ weatherList[1].tempMin }}℃~{{ weatherList[1].tempMax }}℃</div>
          <div class="todayW content_1">后天：天气{{ weatherList[2].textDay }} {{ weatherList[2].tempMin }}℃~{{ weatherList[2].tempMax }}℃</div>
        </div>
        <span class="todayB">
          <el-link type="primary" :underline="false" @click="showGetWeather">
            一周天气
            <i class="el-icon-arrow-right"></i>
          </el-link>
        </span>
      </div>
    </div>
    <el-scrollbar style="height: calc(100% - 135px)">
      <div class="all-content-container">
        <div class="canshu-content-container">
          <div class="environmental-parameters-container" v-if="homeGroupParamDeviceRealDatas.length > 0">
            <div class="content_" v-show="item.deviceRealDatas.length > 0 && item.paramName != '开关状态'" v-for="(item, index) in homeGroupParamDeviceRealDatas" :key="index" style="margin-bottom: 10px">
              <div :span="1" class="homelist-title">
                <div class="grid-content bg-purple canshu-bg">
                  <h3 class="a333">{{ item.paramName }}</h3>
                </div>
              </div>
              <div :span="23" class="card-el-col a23">
                <div class="content_grid">
                  <div :xl="24" v-for="(item2, index2) in item.deviceRealDatas" :key="index2">
                    <div :xs="8" :sm="6" :md="4" :lg="3" :xl="1" class="grid-content bg-purple a65" :class="item2.className">
                      <div class="parameters-list-header_">
                        <span class="list-header-name">{{ item2.deviceName }}</span>
                        <p>
                          <span v-if="item2.deviceStatus == '1'" class="zx-status"> <i class="iconfont icon-yuandianxiao"></i>在线 </span>
                          <span v-else-if="item2.deviceStatus == '2'" class="jg-status"> <i class="iconfont icon-yujing jg-status"></i>告警 </span>
                          <span v-else-if="item2.deviceStatus == '0'" class="lx-status"> <i class="iconfont icon-yuandianxiao"></i>离线 </span>
                        </p>
                      </div>
                      <div class="parameters-list-main_">
                        <div class="list-main-left">
                          <div>
                            <img class="img_wH" :src="item2.attributeImage" />
                          </div>
                        </div>
                        <div class="list-main-right">
                          <p>{{ item2.attributeName }}</p>
                          <span class="a36" v-if="item2.deviceStatus == 1"> {{ item2.realDataConvert }}{{ item2.attributeSymbol }} </span>
                          <span v-if="item2.deviceStatus == 2" class="a36 jg-status"> {{ item2.realDataConvert }}{{ item2.attributeSymbol }} </span>
                          <span v-if="item2.deviceStatus == 0" class="a36 lx-status"> {{ item2.realDataConvert }}{{ item2.attributeSymbol }} </span>
                        </div>
                      </div>
                      <div class="parameters-list-footer_">
                        <div class="acquisition-time hq-time">
                          <span v-if="item2.deviceStatus == '1'">{{ item2.updateTime | zhDatetime }}</span>
                          <span v-if="item2.deviceStatus == '2'" class="jg-status">{{ item2.updateTime | zhDatetime }}</span>
                          <span v-if="item2.deviceStatus == '0'" class="lx-status">{{ item2.updateTime | zhDatetime }}</span>
                        </div>
                        <div class="data-graph">
                          <span @click="show(item2.attributeId, item2.deviceId, item2.attributeName, item2.deviceName)">
                            数据曲线图
                            <i class="el-icon-arrow-right"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="shipin-content-container" v-if="homeGroupParamDeviceVideoDatas.length > 0">
          <div class="environmental-parameters-container">
            <el-row v-show="item.deviceVideoDatas.length > 0" v-for="(item, index) in homeGroupParamDeviceVideoDatas" :key="index">
              <el-col :span="1" class="homelist-title">
                <div class="grid-content bg-purple canshu-bg">
                  <h3>{{ item.paramName }}</h3>
                </div>
              </el-col>
              <el-col :span="22" class="card-el-col">
                <el-row>
                  <el-col :xl="24" v-for="(item2, index2) in item.deviceVideoDatas" :key="index2">
                    <div class="grid-content bg-purple shipin-content">
                      <div class="shipin-title">
                        <span></span>
                        <!-- <span class="zx-status" v-if="item2.deviceStatus == 1">
                          <i class="iconfont icon-yuandianxiao"></i>在线
                        </span>
                        <span class="zx-statu" v-if="item2.deviceStatus == 0" style="color: red">
                          <i class="iconfont icon-yuandianxiao"></i>离线
                        </span> -->
                      </div>
                      <div v-if="videoShow" style="height: auto; width: 100%">
                        <player :id="'play' + item2.deviceId" :deviceUrl="item2.deviceUrl" :accessToken="item2.ysAccessToken"></player>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <el-dialog :title="deviceName + '_' + attributeName + '_' + '曲线图'" :visible.sync="centerDialogVisible" width="1200px" center @open="open()" class="qxtu">
      <el-radio-group v-model="tabPosition" style="margin-top: -20px; margin-bottom: 10px; margin-right: 20px; margin-bottom: 20px">
        <el-radio-button label="图表" style="height: 30px"></el-radio-button>
        <el-radio-button label="列表" style="height: 30px"></el-radio-button>
      </el-radio-group>
      <el-row>
        <el-button type="text" :class="timeType == 0 ? 'timeC' : ''" @click="getChartTime(1, 0)">一小时</el-button>
        <el-button type="text" :class="timeType == 1 ? 'timeC' : ''" @click="getChartTime(24, 1)">一天内</el-button>
        <el-button type="text" :class="timeType == 2 ? 'timeC' : ''" @click="getChartTime(24 * 7, 2)">一周内</el-button>
        <el-button type="text" :class="timeType == 3 ? 'timeC' : ''" @click="getChartTime(24 * 30, 3)" style="margin-right: 30px !important">一个月内</el-button>
        <el-button type="text" :class="timeType == 4 ? 'timeC' : ''" @click="customTime()">自定义</el-button>
        <el-date-picker v-if="timeType == 4" v-model="value1" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeOneTime" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
        <!-- <el-button class="sbBtn" type="primary" style="margin-left: 100px" @click="toDeviceManagement(eid)">设备</el-button> -->
      </el-row>
      <div v-if="tabPosition == '列表'">
        <el-table border :data="tableData1" style="width: 100%; height: 464px">
          <el-table-column align="center" prop="deviceName" label="设备名称"></el-table-column>
          <el-table-column align="center" prop="attributeName" label="属性名称"></el-table-column>
          <el-table-column align="center" prop="value" label="数值"></el-table-column>
          <el-table-column align="center" prop="createDate" label="平台数据接收时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createDate | zhDatetime }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="selectDate" label="平台指令下发时间">
            <template slot-scope="scope">
              <span>{{ scope.row.selectDate | zhDatetime }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="averageResponseTime" label="平均响应时间"></el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange2" :current-page="currentPage4" :page-size="pageSize1" :total="total2" style="float: right; margin-top: 10px"></el-pagination>
      </div>
      <div v-else-if="tabPosition == '图表'" id="mainOne" style="width: 100%; height: 500px; display: inline-block"></div>
    </el-dialog>
    <!-- 添加农作物弹窗 -->
    <el-dialog title="添加农作物" :visible.sync="addCenterDialogVisible" width="700px" center style="z-index: 10000">
      <div class="cropsList">
        <el-button @click="cropShow" plain>农作物列表</el-button>
      </div>

      <div class="info-content-container info-content-container-add">
        <el-form :inline="true" :model="dialogform" :rules="dialogformRules" ref="dialogform">
          <i class="icom_dailog">*</i>
          <el-form-item label="农作物图片：" prop="image" label-width="98px">
            <el-upload class :action="$serverUrl + '/pc/growthCrop/uploadImage'" :headers="headers" name="file" :limit="10" :on-exceed="handleExceed" :show-file-list="false" :on-success="handleAvatarSuccess" :on-progress="handleAvatarProgress" :before-upload="beforeAvatarUpload">
              <img v-if="show" :src="dialogform.image" class="avatar" />
              <i v-if="!show" class="avatar-uploader-icon icon_border">
                <i class="el-icon-plus"></i>
              </i>
            </el-upload>
          </el-form-item>
          <el-form-item label="农作物名称：" prop="name">
            <el-input class="el-dailog_width" v-model="dialogform.name" placeholder="请输入农作物名称" style="width: 344px" maxlength="20" clearable></el-input>
          </el-form-item>
          <br />
          <i class="icom_dailog2">*</i>
          <el-form-item label-width="96px" label="种植大棚：" prop="dialogformModelStageId">
            <el-cascader class="el-dailog_width" v-model="dialogform.dialogformModelStageId" :options="options" :props="{ expandTrigger: 'hover' }" placeholder="请选择种植大棚" collapse-tags clearable></el-cascader>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="cancellation">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogform')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="addressDivide + '未来一周天气概况'" :visible.sync="weatherDialogVisible" width="850px">
      <div class="today-weather">
        <div class="today-weather-title">
          <!-- <img v-if="weatherList_.wType == 0" src="../../static/img/weather-ty.png" />
          <img v-else-if="weatherList_.wType == 3" src="../../static/img/weather-xy.png" />
          <img v-else-if="weatherList_.wType == 2" src="../../static/img/weather-dy.png" />
          <img v-else src="../../static/img/weather-day.png" /> -->
          <i v-if="weatherList_.length > 0" style="font-size: 110px" :class="`qi-${weatherList_[0].iconDay}`"></i>
          <span v-if="weatherList_.length > 0">{{ weatherList_[0].tempMin }}~{{ weatherList_[0].tempMax }}℃</span>
        </div>
        <p v-if="weatherList_.length > 0">今天：{{ weatherList_[0].fxDate }}&nbsp;</p>
        <p v-if="weatherList_.length > 0" class="imgP">
          <!-- <i>
            <img src="../../static/img/feng.png" alt class="imgPp" />
          </i> -->
          {{ weatherList_[0].textDay }}
        </p>
      </div>
      <div class="week-wather">
        <el-row :gutter="20">
          <el-col v-if="index != 0" :span="4" v-for="(item, index) in weatherList_" :key="index">
            <div class="grid-content bg-purple">
              <p style="font-size: 20px">{{ item.fxDate }}</p>
              <div class="imgDiv">
                <!-- <img v-if="item.Wtype == 0" src="../../static/img/week-ty.png" alt />
                <img v-else-if="item.Wtype == 1" src="../../static/img/week-day.png" alt />
                <img v-else-if="item.Wtype == 2" src="../../static/img/week-dy.png" alt />
                <img v-else src="../../static/img/week-xy.png" alt /> -->
                <i style="font-size: 40px" :class="`qi-${item.iconDay}`"></i>
              </div>
              <p style="font-size: 18px">{{ item.tempMin }}~{{ item.tempMax }}℃</p>
              <p style="font-size: 16px">{{ item.textDay }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import layout from '@/components/layout/layout.vue'
import player from '@/components/play/EZUIPlayer.vue'
import marqueeLeft from '@/components/marqaee.vue'
// import echarts from 'echarts'

export default {
  name: 'homePage',
  components: {
    player,
    layout,
    marqueeLeft
  },
  data() {
    return {
      tabPosition: '图表',
      total2: 0,
      alermlist: [],
      attributeName: '',
      msg: 'gaojin',
      weatherList: [],
      weatherDialogVisible: false,
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      },
      dialogformRules: {
        name: [{ required: true, message: '请输入农作物名称', trigger: 'blur' }]
      },
      options: [],
      dialogformName: '',
      dialogformModelStageId: [],
      dialogform: {
        stageName: this.dialogformName,
        groupName: '',
        id: '',
        addDesignImgs: '',
        name: '',
        modelId: '',
        ModelStageId: this.dialogformModelStageId
      },
      headers: {
        // 身份验证
        AUTHORIZATION: sessionStorage.getItem('TOKEN')
      },
      name: '',
      value1: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '一小时内',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近五天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 5)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '一周内',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      timeOne: '',
      pageNum: 1,
      pageSize: 5,
      status: '',
      id: '',
      eid: '1',
      centerDialogVisible: false,
      addCenterDialogVisible: false,
      tubiaoList: [],
      biaogeList: [],
      date: '',
      begDate: '',
      endDate: '',
      attributeName: '',
      deviceName: '',
      timeType: 0,
      cropsId: '',
      attributeName: '',
      deviceType: '',
      groupId: '',
      paramType: '',
      status: '',
      biaogeList: [],
      biaogeList1: [],
      name: '',
      homeGroupParamDeviceRealDatas: [], // 实时数据数组
      homeGroupParamDeviceVideoDatas: [], // 视频数据数组，
      pageSize1: 8,
      currentPage4: 1,
      tableData1: [],
      cityCode: '',
      videoShow: false,
      weatherList_: []
    }
  },
  beforeCreate() {
    this.$forceUpdate()
  },
  watch: {
    tabPosition(val) {
      this.searchDataHisData()
    }
  },
  created() {
    this.groupId = this.$route.query.greenHouseId
    this.cityCode = this.$route.query.cityCode
    this.addressDivide = this.$route.query.addressDivide
    this.dialogform.dialogformModelStageId = [this.$route.query.oneGroupId, this.$route.query.greenHouseId]
    this.getAlarmList()
    this.getGroupList()
    this.getWeather()

    // 获取大棚参数设备实时数据
    this.getHomeGroupParamDeviceRealDatas()

    // 获取大棚参数设备视频数据
    this.getHomeGroupParamDeviceVideoDatas()

    this.init()

    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      // 获取大棚参数设备实时数据
      _this.getHomeGroupParamDeviceRealDatas()

      // 获取大棚参数设备视频数据
      _this.getHomeGroupParamDeviceVideoDatas()
    }, 30000)

    this.timer1 = setInterval(() => {
      _this.date = new Date() // 修改数据date
    }, 30000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.timer1) {
      clearInterval(this.timer1)
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize1 = val
      this.getSetDataHisDataListLook()
    },
    handleCurrentChange2(val) {
      this.currentPage4 = val
      this.getSetDataHisDataListLook()
    },
    // 获取历史数据列表
    getSetDataHisDataListLook(data) {
      if (this.timeType == '4') {
        //自定义时间段
        var begDate = this.begDate
        var endDate = this.endDate
        var datatype = undefined
      } else {
        var begDate = undefined
        var endDate = undefined
        var datatype = this.timeType
      }

      this.$api.system.getDataHisDataList(begDate, endDate, this.id, datatype, this.eid, this.currentPage4, this.pageSize1).then(res => {
        if (res.code == 200) {
          this.total2 = res.pageInfo.total
          this.tableData1 = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取大棚参数设备实时数据
    getHomeGroupParamDeviceRealDatas() {
      this.$api.homeParam
        .getHomeGroupParamDeviceRealDatas({
          id: this.dialogform.dialogformModelStageId[1]
        })
        .then(res => {
          if (res.code == 200) {
            this.homeGroupParamDeviceRealDatas = []
            res.data.forEach(val => {
              if (val.deviceRealDatas.length > 0) {
                this.homeGroupParamDeviceRealDatas.push(val)
              }
            })
          }
        })
    },
    // 获取大棚参数设备视频数据
    getHomeGroupParamDeviceVideoDatas() {
      this.videoShow = false
      this.$api.homeParam
        .getHomeGroupParamDeviceVideoDatas({
          id: this.dialogform.dialogformModelStageId[1]
        })
        .then(res => {
          this.videoShow = true
          if (res.code == 200) {
            this.homeGroupParamDeviceVideoDatas = []
            res.data.forEach(val => {
              if (val.deviceVideoDatas.length > 0) {
                this.homeGroupParamDeviceVideoDatas.push(val)
              }
            })
          }
        })
    },
    // 跳转设备管理
    toDeviceManagement(id) {
      this.$router.push({
        name: 'deviceManagement',
        query: {
          id: id,
          currentShow: 'second',
          currentShow1: 'first'
        }
      })
    },
    getAlarmList() {
      this.$api.system.getAlarmList().then(res => {
        if (res.code == 200) {
          this.alermlist = res.data
        }
      })
    },
    // 查询全部生长模型列表
    changeOne_Time(val) {
      if (!val || val.length < 2) {
        this.$message.warning('请选择二级大棚')
        this.dialogform.dialogformModelStageId = []
        return
      }
      var id = val[val.length - 1]
      this.listhomelist(id)
      this.groupId = id
      this.getWeather()

      // 获取大棚参数设备实时数据
      this.getHomeGroupParamDeviceRealDatas()

      // 获取大棚参数设备视频数据
      this.getHomeGroupParamDeviceVideoDatas()
    },

    // 获取天气
    getWeather() {
      this.$api.system
        .getHfPreWeather({ str: this.cityCode })
        .then(res => {
          if (res.code == 200) {
            // if (res.data.type == '小到中雨') {
            //   res.data.wType = 1
            // } else if (res.data.type == '阴' || res.data.type == '多云') {
            //   res.data.wType = 2
            // } else if (res.data.type == '小雨') {
            //   res.data.wType = 3
            // } else if (res.data.type == '晴') {
            //   res.data.wType = 0
            // }
            // for (var i = 0; i < res.data.forecast.length; i++) {
            //   if (res.data.forecast[i].type == '小到中雨') {
            //     res.data.forecast[i].Wtype = 1
            //   } else if (res.data.forecast[i].type == '阴' || res.data.forecast[i].type == '多云') {
            //     res.data.forecast[i].Wtype = 2
            //   } else if (res.data.forecast[i].type == '小雨') {
            //     res.data.forecast[i].Wtype = 3
            //   } else if (res.data.forecast[i].type == '晴') {
            //     res.data.forecast[i].Wtype = 0
            //   }
            // }
            this.weatherList = res.data
            console.log(this.weatherList)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    //清空
    empty() {
      this.dialogform.dialogformModelStageId = ''
      this.dialogform.name = ''
      this.dialogform.image = ''
    },
    //二级
    changeTreeItem(val) {
      this.dialogformInline.parentId = val[val.length - 1]
      this.formInline.organization = val[val.length - 1]
    },
    //初始化
    init() {
      this.getNumericalAttributeList()
    },
    //到物质
    cropShow() {
      this.$router.push({
        name: 'cropsManagement'
      })
    },
    //
    showGetWeather() {
      this.get7Weather()
      this.weatherDialogVisible = true
    },

    // 农作物添加
    addCrops() {
      this.empty()
      this.getGroupList()
      this.addCenterDialogVisible = true
      this.cropsId = ''
      // this.empty()
      // this.show = false;
    },
    // 图表时间点击
    getChartTime(time1, type) {
      console.log(type)
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * time1)
      this.begDate = this.zhDatetime1(start)
      this.endDate = this.zhDatetime1(end)
      this.timeType = type
      // this.getDataHisDataChart()
      this.searchDataHisData()
      this.value1 = []
    },
    // 自定义点击
    customTime() {
      this.timeType = 4
      this.value1 = []
    },
    // 查询历史数据
    searchDataHisData() {
      if (this.tabPosition == '图表') {
        this.getDataHisDataChart()
      } else {
        this.getSetDataHisDataListLook()
      }
    },
    // 时间选择
    changeOneTime(val) {
      if (val) {
        this.begDate = this.zhDatetime1(val[0])
        this.endDate = this.zhDatetime1(val[1])
        if (this.tabPosition == '图表') {
          this.getDataHisDataChart()
        } else {
          this.getSetDataHisDataListLook()
        }
      }
    },
    zhDatetime(t) {
      if (t == '' || t == null || t == undefined) {
        return ''
      } else {
        var d = new Date(t)
        // d.setTime(t);
        var Y = d.getFullYear()
        var M = d.getMonth() + 1
        var D = d.getDate()
        var h = d.getHours()
        var m = d.getMinutes()
        var s = d.getSeconds()
        M = M > 9 ? M : '0' + M
        D = D > 9 ? D : '0' + D
        h = h > 9 ? h : '0' + h
        m = m > 9 ? m : '0' + m
        s = s > 9 ? s : '0' + s
        return h + ':' + m + ':' + s
      }
    },
    zhDatetime1(t) {
      if (t == '' || t == null || t == undefined) {
        return ''
      } else {
        var d = new Date(t)
        var Y = d.getFullYear()
        var M = d.getMonth() + 1
        var D = d.getDate()
        var h = d.getHours()
        var m = d.getMinutes()
        var s = d.getSeconds()
        M = M > 9 ? M : '0' + M
        D = D > 9 ? D : '0' + D
        h = h > 9 ? h : '0' + h
        m = m > 9 ? m : '0' + m
        s = s > 9 ? s : '0' + s
        return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s
      }
    },
    handleAvatarProgress(event, file, fileList) {
      // 文件上传时的进度
      this.isUpdateSuccess = true
      var timer = setInterval(() => {
        this.imgUpdateProgress += 10
        if (this.imgUpdateProgress >= 90) {
          clearInterval(timer)
        }
      }, 200)
    },
    goback() {
      this.$router.push({
        name: 'homePage',
        query: {
          oneGroupId: this.dialogform.dialogformModelStageId[0]
        }
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传10张图片`)
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.srcList = []
        this.show = true
        this.$forceUpdate()
        this.dialogform.image = res.data
        this.$toaster.ok(res.msg)

        this.imgUpdateProgress = 100
        setTimeout(() => {
          this.isUpdateSuccess = false
          this.imgUpdateProgress = 0
        }, 200)
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isSize = file.size / 1024 / 1024 < 5

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 、PNG 格式!')
      }
      if (!isSize) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isJPG && isSize
    },
    cancellation() {
      this.addCenterDialogVisible = false
    },
    open() {
      const t = this
      setTimeout(() => {
        //  执行echarts画图方法
        t.getDataHisDataChart()
      }, 0)
    },
    show(name, eid, attributeName, deviceName) {
      this.id = name
      this.eid = eid
      this.attributeName = attributeName
      this.deviceName = deviceName
      // 默认1小时
      this.getChartTime(1, 0)
      this.centerDialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogform.image == '' || !this.dialogform.image) {
            return this.$message.error('请选择农作物图片')
          }
          if (this.dialogform.dialogformModelStageId == '' || !this.dialogform.dialogformModelStageId) {
            return this.$message.error('请选择种植大棚')
          }
          this.saveGrowthCrop()
        } else {
          return
        }
      })
    },
    // 保存农作物
    saveGrowthCrop() {
      let data = new FormData()
      data.append('image', this.dialogform.image)
      data.append('id', this.id)
      data.append('name', this.dialogform.name)
      data.append('groupId', this.dialogform.dialogformModelStageId)
      this.$api.system
        .saveGrowthCrop(data)
        .then(res => {
          if (res.code == 200) {
            this.addCenterDialogVisible = false
            this.$router.push({
              name: 'cropsManagement'
            })
            this.$message({
              type: 'success',
              message: res.msg
            })
          } else {
            this.addCenterDialogVisible = false
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    // 查询所有生长阶段
    getGrowthModelStages() {
      this.$api.system.getGrowthModelStageshome().then(res => {})
    },
    // 查询全部生长模型列表/
    listhomelist(groupId) {
      this.$api.system.listhome(this.pageNum, 9999, groupId, '').then(res => {
        if (res.code == 200) {
          this.listhome = res.data
        }
      })
    },
    // 告警跳转
    gjtzShow() {
      this.$emit('func', this.msg)
      this.$router.push({
        path: '/alarmPredictions',
        query: { currentShow: 'pane1', currentShow2: 'pane3' }
      })
      this.$refs.pass.moreBth()
    },
    get7Weather() {
      this.$api.system
        .getHfPreWeather({ str: this.cityCode })
        .then(res => {
          if (res.code == 200) {
            // if (res.data.type == '小到中雨') {
            //   res.data.wType = 1
            // } else if (res.data.type == '阴' || res.data.type == '多云') {
            //   res.data.wType = 2
            // } else if (res.data.type == '小雨') {
            //   res.data.wType = 3
            // } else if (res.data.type == '晴') {
            //   res.data.wType = 0
            // }
            // for (var i = 0; i < res.data.forecast.length; i++) {
            //   if (res.data.forecast[i].type == '小到中雨') {
            //     res.data.forecast[i].Wtype = 1
            //   } else if (res.data.forecast[i].type == '阴' || res.data.forecast[i].type == '多云') {
            //     res.data.forecast[i].Wtype = 2
            //   } else if (res.data.forecast[i].type == '小雨') {
            //     res.data.forecast[i].Wtype = 3
            //   } else if (res.data.forecast[i].type == '晴') {
            //     res.data.forecast[i].Wtype = 0
            //   }
            // }
            this.weatherList_ = res.data
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    // 大棚名称
    getGroupList() {
      this.$api.system
        .getGroupList()
        .then(res => {
          if (res.code == 200) {
            for (var i = 0; i < res.data.length; i++) {
              res.data[i].label = res.data[i].name
              res.data[i].value = res.data[i].id
              if (res.data[i].children) {
                for (var j = 0; j < res.data[i].children.length; j++) {
                  res.data[i].children[j].label = res.data[i].children[j].name
                  res.data[i].children[j].value = res.data[i].children[j].id
                }
              }
            }
            this.options = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    getNumericalAttributeList() {
      this.$api.system.getNumericalAttributeList(this.pageNum, this.pageSize, this.status).then(res => {
        if (res.code == 200) {
          var arr1 = [
            [require('@/static/homeImg/kq0.png'), require('@/static/homeImg/kq1.png'), require('@/static/homeImg/kq2.png')],
            [require('@/static/homeImg/co0.png'), require('@/static/homeImg/co1.png'), require('@/static/homeImg/co2.png')],
            [require('@/static/homeImg/ty0.png'), require('@/static/homeImg/ty1.png'), require('@/static/homeImg/ty2.png')],
            [require('@/static/homeImg/gh0.png'), require('@/static/homeImg/gh1.png'), require('@/static/homeImg/gh2.png')],
            [require('@/static/homeImg/dq0.png'), require('@/static/homeImg/dq1.png'), require('@/static/homeImg/dq2.png')],
            [require('@/static/homeImg/ypw0.png'), require('@/static/homeImg/ypw1.png'), require('@/static/homeImg/ypw2.png')],
            [require('@/static/homeImg/yps0.png'), require('@/static/homeImg/yps1.png'), require('@/static/homeImg/yps2.png')],
            [require('@/static/homeImg/sg0.png'), require('@/static/homeImg/sg1.png'), require('@/static/homeImg/sg2.png')],
            [require('@/static/homeImg/wbh0.png'), require('@/static/homeImg/wbh1.png'), require('@/static/homeImg/wbh2.png')],
            [require('@/static/homeImg/gspd0.png'), require('@/static/homeImg/gspd1.png'), require('@/static/homeImg/gspd2.png')],
            [require('@/static/homeImg/trs0.png'), require('@/static/homeImg/trs1.png'), require('@/static/homeImg/trs2.png')],
            [require('@/static/homeImg/trsd0.png'), require('@/static/homeImg/trsd1.png'), require('@/static/homeImg/trsd2.png')],
            [require('@/static/homeImg/phz0.png'), require('@/static/homeImg/phz1.png'), require('@/static/homeImg/phz2.png')],
            [require('@/static/homeImg/try0.png'), require('@/static/homeImg/try1.png'), require('@/static/homeImg/try2.png')],
            [require('@/static/homeImg/trjs0.png'), require('@/static/homeImg/trjs1.png'), require('@/static/homeImg/trjs2.png')]
          ]
          res.data.forEach((val, index) => {
            val.image = arr1[index]
            if (val.deviceStatus == '1') {
              val.className = ''
            } else if (val.deviceStatus == '2') {
              val.className = 'jg-border'
            } else if (val.deviceStatus == '0') {
              val.className = 'lx-border'
            }
          })

          var arr = [[], [], []]
          for (var i = 0; i < res.data.length; i++) {
            if (i < 5) {
              arr[0].push(res.data[i])
            } else if (i >= 5 && i < 10) {
              arr[1].push(res.data[i])
            } else if (i >= 10) {
              arr[2].push(res.data[i])
            }
          }
        } else {
          this.loading = false //关闭加载
        }
      })
    },
    getDataHisDataChart() {
      // this.loading=true;//开启加载 this.timeType,
      this.$api.system.getDataHisDataChart(this.id, this.eid, this.begDate, this.endDate).then(res => {
        if (res.code == 200) {
          //  this.loading=false;//关闭加载
          //  this.$meessage({type:'success',message:res.msg})
          this.tubiaoList = res.data
          let x = []
          let y = []
          let z = []
          var arr = []
          var obj = {}
          for (var i = 0; i < res.data.xTimes.length; i++) {
            x.push(this.zhDatetime1(res.data.xTimes[i]))
          }
          for (var j = 0; j < res.data.yDatas.length; j++) {
            arr.push(res.data.yDatas[j].value)
          }
          obj.type = 'line'
          obj.data = arr
          obj.symbol = 'none'
          obj.smooth = true
          obj.lineStyle = { color: '#0356fe' }
          obj.areaStyle = {
            normal: {
              color: 'rgba(3,86,254,.3)' //改变区域颜色
            }
          }

          y.push(obj)
          z.push(this.attributeName)
          this.initChart(x, y, z)
        } else {
          this.loading = false //关闭加载
          this.$meessage.error(res.msg)
        }
      })
    },

    initChart(x, y, z) {
      var myChart = document.getElementById('mainOne')
      var chartObj = echarts.init(myChart)
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        color: ['#0356fe'],
        legend: {
          data: z,
          textStyle: {
            //图例文字的样式
            color: '#6a7985',
            fontSize: 14
          },
          x: 'center', //可设定图例在左、右、居中
          y: 'bottom'
        },
        xAxis: {
          axisLabel: {
            showMaxLabel: true
          },
          type: 'category',
          // axisLabel:{//倾斜
          //   rotate:-60
          // },
          data: x,
          splitLine: {
            show: false,
            lineStyle: {
              color: ['#ccc'],
              width: 1,
              type: 'solid'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#333',
              width: 1 //这里是为了突出显示加上的
            }
          },
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
            lineStyle: {
              color: ['#ccc'],
              width: 1,
              type: 'solid'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#333',
              width: 1 //这里是为了突出显示加上的
            }
          },
          boundaryGap: false
          // inverse: true
        },
        series: y,
        grid: {
          x: 30,
          x2: 20,
          y: 20,
          left: '10%',
          right: '10%',
          bottom: '10%'
        }
      }
      chartObj.setOption(option)
    },
    // 跳转首页参数配置界面
    hanldeHomeParam() {
      this.$router.push({
        name: `homeParam`,
        query: {
          greenHouseId: this.dialogform.dialogformModelStageId[1],
          oneGroupId: this.dialogform.dialogformModelStageId[0]
        }
      })
    }
  },
  computed: {
    // 当前选中id的最后一个
    cateId() {
      if (this.dialogform.dialogformModelStageId.length === 2) {
        return this.dialogform.dialogformModelStageId[1]
      }
      return null
    }
  }
}
</script>

<style lang="scss">
.logo-img-top {
  width: 200px;
}
.todayW {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.early-warning-container {
  display: flex;
  .waring_lable {
    width: 80px;
    white-space: nowrap;
  }
}
.icon_border {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}

.img_wH {
  width: 65px;
  height: 65px;
  margin-right: 30px;
}
.sbBtn {
  color: #ffffff !important;
  span {
    color: #ffffff !important;
  }
}
.canshu-content-container {
  min-height: 800px;
}
.content_ {
  display: flex;
  align-items: center;
}
.content_grid {
  width: 98%;
  margin-left: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}
.a23 {
  width: 100%;
}
.a333 {
  width: 20px;
  // white-space: br;
  margin-left: 15px;
  margin-right: 15px;
  color: #333;
  word-wrap: break-word;
}
.parameters-list-header_ {
  display: flex;
  justify-content: space-between;
}
.a65 {
  background-color: #ffffff;
  margin: 10px;
  padding: 15px;
  border-radius: 5px;
}
.parameters-list-main_ {
  display: flex;
  margin-bottom: 20px;
  margin-top: 15px;
}
.parameters-list-footer_ {
  font-size: 14px !important;
  display: flex;
  justify-content: space-between;
}
.container_1 {
  margin-top: 5px;
  height: 70px;
  width: 400px;
  overflow: hidden;
}
/* 设置内容的样式 */
.content_1 {
  position: relative;
  top: 0;
  white-space: nowrap;
  animation: scroll-up 12s linear infinite;
}
/* 定义动画效果 */
@keyframes scroll-up {
  0% {
    transform: translateY(-15%);
  }
  20% {
    transform: translateY(-15%);
  }
  40% {
    transform: translateY(-150%);
  }
  60% {
    transform: translateY(-150%);
  }
  70% {
    transform: translateY(-290%);
  }
  90% {
    transform: translateY(-290%);
  }
  100% {
    transform: translateY(-400%);
  }
}
.a36 {
  font-weight: 500;
  margin-top: 30px;
  font-size: 30px;
  color: #358c21;
  line-height: 35px;
  text-align: left;
  font-style: normal;
}
</style>
